/* bal-tool-ui.js: presentation-only enhancement for /tools and /tools/*. Vanilla, no deps.
 * PRIVACY CONTRACT (same as bal-tool.js; enforced by scripts/guards/check-tools-packages.mjs):
 *  - reads nothing the visitor types; writes nothing to the URL, storage, cookies or the network.
 * It does three things, all optional (every word is already in the server HTML):
 *  1. reveal-on-scroll for .bal-reveal blocks (skipped entirely under prefers-reduced-motion);
 *  2. the mobile "Jump to tool" pill, hidden while the tool card is on screen;
 *  3. hub topic chips: filter the groups in place (without JS they are plain in-page links).
 */
(function () {
  'use strict';
  var doc = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  // 1. reveal
  var blocks = doc.querySelectorAll('.bal-reveal');
  if (!reduce && hasIO && blocks.length) {
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    blocks.forEach(function (b) {
      if (b.getBoundingClientRect().top < vh) b.classList.add('is-in'); // above the fold: no flash
      else io.observe(b);
    });
    doc.querySelectorAll('.bal-tool').forEach(function (r) { r.classList.add('bal-anim'); });
  }

  // 2. mobile jump pill
  var page = doc.querySelector('.bal-tool--page');
  var stage = doc.getElementById('tool');
  var jump = doc.querySelector('[data-tool-jump]');
  if (page && stage && jump && hasIO) {
    page.classList.add('bal-has-jump');
    jump.classList.add('is-hidden');
    var hero = doc.querySelector('.bal-tool__hero');
    var heroVisible = true, stageVisible = false;
    var sync = function () { jump.classList.toggle('is-hidden', heroVisible || stageVisible); };
    new IntersectionObserver(function (es) { es.forEach(function (e) { stageVisible = e.isIntersecting; }); sync(); }).observe(stage);
    if (hero) new IntersectionObserver(function (es) { es.forEach(function (e) { heroVisible = e.isIntersecting; }); sync(); }).observe(hero);
    jump.addEventListener('click', function () {
      setTimeout(function () { try { stage.focus({ preventScroll: true }); } catch (e) {} }, 400);
    });
  }

  // 3. hub filters
  var hub = doc.querySelector('[data-tools-hub]');
  if (hub) {
    var chips = hub.querySelectorAll('[data-filter]');
    var groups = hub.querySelectorAll('[data-group]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function (ev) {
        ev.preventDefault();
        var f = chip.getAttribute('data-filter');
        chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        groups.forEach(function (g) {
          var show = f === 'all' || g.getAttribute('data-group') === f;
          g.hidden = !show;
          if (show) g.classList.add('is-in');
        });
      });
    });
  }
})();
